import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, updateDoc, deleteDoc, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import Navigation from '../components/Navigation';
import './AdminInterests.css';

function AdminInterests() {
  const [interests, setInterests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // all, pending, contacted, resolved

  useEffect(() => {
    fetchInterests();
  }, []);

  async function fetchInterests() {
    try {
      const q = query(collection(db, 'projectInterests'), orderBy('submittedAt', 'desc'));
      const querySnapshot = await getDocs(q);
      const interestsList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setInterests(interestsList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching interests:', error);
      setLoading(false);
    }
  }

  async function handleStatusChange(interestId, newStatus) {
    try {
      await updateDoc(doc(db, 'projectInterests', interestId), {
        status: newStatus
      });
      fetchInterests();
    } catch (error) {
      console.error('Error updating status:', error);
    }
  }

  async function handleDelete(interestId) {
    if (!window.confirm('Are you sure you want to delete this interest?')) {
      return;
    }

    try {
      await deleteDoc(doc(db, 'projectInterests', interestId));
      alert('Interest deleted successfully!');
      fetchInterests();
    } catch (error) {
      console.error('Error deleting interest:', error);
      alert('Failed to delete interest.');
    }
  }

  const filteredInterests = filter === 'all' 
    ? interests 
    : interests.filter(i => i.status === filter);

  return (
    <div className="admin-container">
      <Navigation />
      
      <div className="admin-content">
        <div className="admin-header">
          <div>
            <h1>Project Interests</h1>
            <p>View and manage all interest submissions</p>
          </div>
          <div className="stats">
            <div className="stat-box">
              <strong>{interests.length}</strong>
              <span>Total Interests</span>
            </div>
            <div className="stat-box pending">
              <strong>{interests.filter(i => i.status === 'pending').length}</strong>
              <span>Pending</span>
            </div>
          </div>
        </div>

        <div className="filter-bar">
          <label>Filter by Status:</label>
          <select value={filter} onChange={(e) => setFilter(e.target.value)}>
            <option value="all">All ({interests.length})</option>
            <option value="pending">Pending ({interests.filter(i => i.status === 'pending').length})</option>
            <option value="contacted">Contacted ({interests.filter(i => i.status === 'contacted').length})</option>
            <option value="resolved">Resolved ({interests.filter(i => i.status === 'resolved').length})</option>
          </select>
        </div>

        {loading ? (
          <div className="loading">Loading interests...</div>
        ) : filteredInterests.length === 0 ? (
          <div className="no-data">
            <p>No interests found.</p>
          </div>
        ) : (
          <div className="interests-list">
            {filteredInterests.map(interest => (
              <div key={interest.id} className={`interest-card ${interest.status}`}>
                <div className="interest-header">
                  <div>
                    <h3>{interest.contactName}</h3>
                    <p className="organization">{interest.organizationName}</p>
                  </div>
                  <div className="interest-actions">
                    <select
                      value={interest.status}
                      onChange={(e) => handleStatusChange(interest.id, e.target.value)}
                      className="status-select"
                    >
                      <option value="pending">Pending</option>
                      <option value="contacted">Contacted</option>
                      <option value="resolved">Resolved</option>
                    </select>
                    <button 
                      onClick={() => handleDelete(interest.id)}
                      className="delete-btn"
                      title="Delete"
                    >
                      🗑️
                    </button>
                  </div>
                </div>

                <div className="interest-body">
                  <div className="info-row">
                    <strong>Project:</strong>
                    <span>{interest.projectTitle}</span>
                  </div>
                  
                  <div className="info-row">
                    <strong>Email:</strong>
                    <a href={`mailto:${interest.contactEmail}`}>{interest.contactEmail}</a>
                  </div>
                  
                  <div className="info-row">
                    <strong>Submitted:</strong>
                    <span>
                      {interest.submittedAt?.toDate?.().toLocaleDateString() || 'N/A'} 
                      {' at '}
                      {interest.submittedAt?.toDate?.().toLocaleTimeString() || ''}
                    </span>
                  </div>

                  {interest.message && (
                    <div className="message-section">
                      <strong>Message:</strong>
                      <p>{interest.message}</p>
                    </div>
                  )}
                </div>

                <div className="interest-footer">
                  <a 
                    href={`mailto:${interest.contactEmail}?subject=Re: ${interest.projectTitle}`}
                    className="reply-btn"
                  >
                    📧 Reply via Email
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminInterests;
